import React, { createContext, useEffect, useRef, useState } from 'react';
import api from '../services/api';
export const DashboardContext = createContext({});

function DashboardProvider({ children }) {

    const [totalCartsLoss,setTotalCartsLoss] = useState()
    const [total,setTotal] = useState()

    const getAll = async () => {
        const response = await api.get("dashboard/cart/loss/")
        if(response.status == 200){
            setTotalCartsLoss(response.data.total)
        }
    }
    const getTotal = async (id) => {
        const date = id || new Date(); // Use 'id' se fornecido, caso contrário, a data atual
        const response = await api.post("/dashboard/financial/get", { date,status:6 });
        console.log(response.data)

        if(response.status == 200){
            setTotal(response.data.productSale)            
        }
    }

    

    return (
        <DashboardContext.Provider value={{getAll,totalCartsLoss,total,getTotal}}>
            {children}
        </DashboardContext.Provider>
    );
}

export default DashboardProvider;
